import React, { Component } from "react";
import CreateVCForm from "./CreateVCForm";
import Sidebar from "./Sidebar";

class CreateVC extends Component {
  render() {
    return (
      <div className="row">
        <div
          className="col-lg-3 col-md-4 responsive-view fix-height sidebar-height"
          style={{ background: "#f4f4f4" }}
        >
          <Sidebar />
        </div>
        <div
          className="col-lg-9 col-md-8 mb-4 dashboard-content"
          style={{ padding: "20px" }}
        >
          <CreateVCForm />
        </div>
      </div>
    );
  }
}
export default CreateVC;
